const fa = {
  select_from_gallary: 'انتخاب عکس از گالری',
  upload_picture_error: '!فقط امکان آپلود تصویر jpg با حداکثر حجم ۱۰ مگابایت وجود دارد.',
  confirmation_modal_alert: 'شما فقط می‌توانید یک پیام سه دقیقه‌‌ای بفرستید، آیا از ارسال این پیام اطمینان دارید؟',
  send: 'ارسال',
  cancel: 'لغو',
  ticket_status: 'وضعیت درخواست',
  category: 'دسته‌بندی',
  voice_hint_1: 'درخواست خود را در',
  voice_hint_2: 'یک پیام صوتی ',
  voice_hint_3: 'حداکثر',
  voice_hint_4: 'سه دقیقه ای',
  voice_hint_5: 'مطرح کنید.',
  record_your_voice: 'صدای خود را ضبط نمایید.',
  write_your_message: 'پیام خود را بنویسید...',
  change_status_alert: 'قبل از خروج وضعیت درخواست را تغییر دهید.',
  message_limit_alert: 'شما فقط یک پیام صوتی حداکثر سه‌دقیقه‌ای می‌توانید ارسال کنید.',
  category_limit_alert: 'در این دسته‌بندی نمی‌توانید پیام صوتی ارسال کنید و فقط می‌توانید پیام متنی ارسال کنید.',
  estekhare_header_1: 'لطفا با توجه به موارد زیر تعداد نیات خود را درج نمایید:',
  estekhare_header_2: 'برای انجام هر فعل یک نیت لازم است و نیت نباید بین این دو فعل انجام شود، مثلا اگر صلاح است فلان وسیله را بخرم استخاره خوب بیاید و اگر صلاح نیست بد بیاید نه به این صورت نیت کنید که این وسیله را بخرم یا نخرم.',
  estekhare_header_3: 'اگر برای یک موضوع چند مطلب هست، مثلا سه مدرسه برای ثبت نام مدنظر دارم، برای هر کدام یک نیت به صورت مجزا انجام شود و حتما قید گردد که این استخاره مقایسه‌ای است، یعنی از بین این سه مورد کدام بهتر است.',
  estekhare_header_4: 'استخاره‌های ترک صرفا برای استخاره‌های خوب می‌باشد و استخاره بد نیاز به ترک ندارد، چنانچه نیاز به ترک استخاره داشتید حتما در پیام قید بفرمایید.',
  estekhare_header_5: 'لطفا قبل از ارسال، صوت زیر را با دقت گوش نموده و بر اساس آن عمل نمایید.',
  closed_chat: 'این درخواست بسته شده است، لطفا یک درخواست جدید ایجاد کنید.'
}

export default fa
